import { render, staticRenderFns } from "./ClosedBisTable.vue?vue&type=template&id=230eaa68&"
import script from "./ClosedBisTable.vue?vue&type=script&lang=js&"
export * from "./ClosedBisTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports